// snippet: rcep
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import styles from './AdminPanelStockForm.styles';
import AdminPanelStockFormControls from './AdminPanelStockFormControls';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';
import axios from 'axios';
import { updateData, initialData } from '../../../api/common/actions';
import { readSettings } from '../../../helpers/board';
import box_type_enum from '../../Common/box_type_enum';

export class AdminPanelStockForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      retryAttempts: 0,
      maxRetries: 3
    };
  }
  handleBack = () => {
    this.props.history.push('/RearStock/AdminPanel');
  };

  onDataSourceChange = async () => {
    let sourceEnabled;
    if (window.electron) {
      const fileData = JSON.parse(readSettings());
      sourceEnabled = fileData ? fileData.dynamicDataSource : false;
    } else {
      sourceEnabled = JSON.parse(localStorage.getItem('dynamicDataSource'));
    }
    if ([true, 'true'].includes(sourceEnabled)) {
      await this.getBoxesData();
    }
  };

  getBoxesData = async () => {
    const { retryAttempts, maxRetries } = this.state;
    let boxId;
    if (window.electron) {
      const fileData = JSON.parse(readSettings());
      boxId = fileData ? fileData.boxId : '';
    } else {
      boxId = localStorage.getItem('boxId');
    }
    const token = localStorage.getItem('authTokens');
    const actualToken = atob(token);
    if (![undefined, 'undefined', null, null, ''].includes(boxId)) {
      return await axios
        .get(`${process.env.REACT_APP_BASEURL}getprescriptions/${boxId}`, {
          headers: {
            Authorization: 'Bearer ' + actualToken,
            'Content-Type': 'application/json'
          },
          timeout: process.env.REACT_APP_REQUEST_TIMEOUT_INTERVAL
        })
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.box &&
            response.data.box.id
          ) {
            this.props.updateData(response.data);
          }
          if (
            response &&
            response.data &&
            response.data.box &&
            response.data.box.type_id === box_type_enum.FASTLANE
          ) {
            localStorage.setItem('boxType', response.data.box.type_id);
          }
          this.props.updateData(response.data);
          return response.data;
        })
        .catch((error) => {
          if (retryAttempts < maxRetries) {
            this.setState(
              { retryAttempts: retryAttempts + 1 },
              this.getBoxesData()
            );
          } else {
            console.log(error);
          }
        });
    }
  };

  render() {
    const { classes, box } = this.props;
    return (
      <div className={classNames(classes.container)}>
        <div className={classNames(classes.form)}>
          <AdminPanelStockFormControls
            onDataSourceChange={this.onDataSourceChange}
            handleBack={this.handleBack}
            box={box}
          />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateData: (box) => dispatch(updateData(box)),
  initialData: (box) => dispatch(initialData(box))
});

export default connect(
  null,
  mapDispatchToProps
)(
  withStyles(styles, { withTheme: true })(
    injectIntl(withRouter(AdminPanelStockForm))
  )
);
